import IconSVG from 'svg-inline-react'
import classnames from 'classnames'
import { getNormalizedTagColor } from 'utils/TagAppearanceHelper'
import TetherComponent from 'react-tether';
import ManageTagDropdown from './ManageTagDropdown'
import TagColorSelectorDropdown from 'components/settings/tags/TagColorSelectorDropdown'
import TagEditingInput from 'components/settings/tags/TagEditingInput'

import PropTypes from 'prop-types'

import 'styles/components/settings/tags/ManageTagsList.styl'

const ManageTagsList = React.createClass({
  propTypes: {
    tagList: PropTypes.array.isRequired,
  },

  getInitialState() {
    return {
      showTagEditingInput: false,
      showColorDropdown: false,
      editingTag: undefined,
      showDropdownTagId: undefined,
    }
  },

  renderTags() {
    return (
      <div className="ManageTagsList tags">
        {_.map(this.props.tagList, tag => {
          if (tag.id === (this.state.editingTag != null ? this.state.editingTag.id : undefined)) {
            return
          }
          return (
            <div
              key={tag.id}
              className="tag"
              style={{
                backgroundColor: `#${getNormalizedTagColor(tag.color)}`,
                color: 'var(--main-navy-extra-dark)',
              }}>
              <div className="tag-label">
                {tag.name}
              </div>
              <IconSVG
                className="configure-tag"
                onClick={this.tagSettingsClicked.bind(this, tag)}
                src={require('!svg-inline?removeTags=true!images/icons/cog-fill-icon.svg')} />
              {tag.id === this.state.showDropdownTagId
                ? <ManageTagDropdown
                handleClickOutside={this.outsideManageTagDropdownClicked}
                editTagClicked={() => this.editTagClicked(tag)}
                deleteTagClicked={() => this.deleteTagClicked(tag)} />
                : undefined}
            </div>
          )
        })}
        {!this.state.showTagEditingInput ? this.renderAddTagButton() : undefined}
      </div>
    )
  },

  renderAddTagButton() {
    return (
      <TetherComponent
        attachment="bottom right"
        targetOffset="39 -275px"
        constraints={[{ to: 'scrollParent', attachment: 'together' }]}
      >
          <div
            className={classnames('add-tag-button', { selected: this.state.showColorDropdown })}
            onClick={this.addTagClicked}>
            <IconSVG
              className="add-tag-plus"
              src={require('!svg-inline?removeTags=true!images/icons/plus-icon.svg')} />
            <span className="tag-button-title">
              Add Tag
            </span>
          </div>
          {this.state.showColorDropdown &&
            <TagColorSelectorDropdown
              colorClicked={this.colorClicked}
              onClickOutside={this.outsideColorSelectDropdownClicked}
            />
          }
      </TetherComponent>
    )
  },

  render() {
    return (
      <div className={classnames('ManageTagsList ', this.props.className)}>
        {this.renderTags()}
        <div className="add-tag">
          {this.state.showTagEditingInput
            ? <TagEditingInput
            selectedColor={this.state.selectedColor}
            editingTag={this.state.editingTag}
            tagType={this.props.tagType}
            onClose={this.cancelCreateTag} />
            : undefined}
        </div>
      </div>
    )
  },

  addTagClicked() {
    return this.setState({ showColorDropdown: !this.state.showColorDropdown })
  },

  colorClicked(tagColor) {
    return this.setState({
      showColorDropdown: false,
      showTagEditingInput: true,
      selectedColor: tagColor,
    })
  },

  cancelCreateTag() {
    return this.setState(this.getInitialState())
  },

  showColorDropdownClicked() {
    return this.setState({ showColorDropdown: true })
  },

  tagSettingsClicked(tag) {
    return this.setState({ showDropdownTagId: tag.id })
  },

  editTagClicked(tag) {
    return this.setState({
      showTagEditingInput: true,
      editingTag: tag,
      selectedColor: tag.color,
      showDropdownTagId: false,
    })
  },

  deleteTagClicked(tag) {
    this.props.app.actions.TagActions.deleteTag(tag.id)
    return this.setState({
      showTagEditingInput: false,
      editingTag: undefined,
      showDropdownTagId: false,
    })
  },

  outsideManageTagDropdownClicked() {
    return this.setState({ showDropdownTagId: undefined })
  },

  outsideColorSelectDropdownClicked(event) {
    return this.setState({ showColorDropdown: false })
  },
})

export default ManageTagsList



// WEBPACK FOOTER //
// ./src/scripts/components/settings/tags/ManageTagsList.js